import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

import DeprecatedFeatureLayout from '../components/deprecated-feature-layout/deprecated-feature-layout.component';

const ColliOverview = lazy(() => import('./colli-overview/colli-overview'));
const ColliDetail = lazy(() => import('./colli-detail/colli-detail.component'));

export function ColliRoutes() {
    return (
        <Route
            path='collis'
            element={<DeprecatedFeatureLayout />}>
            <Route
                index
                element={
                    <AsyncComponent>
                        <ColliOverview />
                    </AsyncComponent>
                }
            />
            <Route
                index
                element={<Navigate to='/admin/collis' />}
            />
            <Route path=':colliId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <ColliDetail />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
